export default [
  {
    value: 'Gerais',
    text: 'Gerais',
  },
  {
    value: 'Clinicos',
    text: 'Clínicos',
  },
  {
    value: 'CirurgicosInvasivos',
    text: 'Cirurgicos Invasivos',
  },
  {
    value: 'DiagnosticosTerapeutico',
    text: 'Diagnosticos Terapeutico',
  },
]
